// @ts-nocheck
// Tour de boas-vindas do clube — overlay full-screen de cards. Dinâmico pra
// config do clube (modo, quem pode postar, papel, ranking, etc). Substitui o
// tutorial guiado de tooltips (frágil) por um "tour" com previews estilizados.
//
// Dispara 1x por clube por device (localStorage forjamente.welcomeSeen.<clubId>).
import React, { useState } from 'react';
import { Icon } from '../icons';

// ── Mini-ilustrações estilizadas (sem screenshots — rendem com a paleta do app) ──
function MiniPostPreview() {
  return (
    <div style={{ background: 'var(--paper-2)', border: '1px solid var(--line)', borderRadius: 14, padding: 12, boxShadow: '0 8px 24px -12px rgba(0,0,0,0.4)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 9 }}>
        <div style={{ width: 26, height: 26, borderRadius: '50%', background: 'linear-gradient(135deg, var(--ember), var(--plum, #C08CAE))' }} />
        <div style={{ flex: 1 }}>
          <div style={{ width: 70, height: 7, borderRadius: 4, background: 'var(--paper-3)' }} />
        </div>
        <span style={{ fontSize: 9, color: 'var(--ember)', fontWeight: 700, letterSpacing: '0.06em' }}>REFLEXÃO</span>
      </div>
      <div style={{ borderLeft: '2px solid var(--plum, #C08CAE)', paddingLeft: 10, marginBottom: 9 }}>
        <div style={{ fontFamily: 'Instrument Serif, Georgia, serif', fontSize: 15, color: 'var(--ink)', lineHeight: 1.3, fontStyle: 'italic' }}>“Quem tem um porquê enfrenta quase qualquer como.”</div>
      </div>
      <div style={{ display: 'flex', gap: 12, color: 'var(--ink-3)', fontSize: 11 }}>
        <span>🙏 12</span><span>💡 8</span><span>🔥 5</span><span style={{ marginLeft: 'auto' }}>4 na discussão</span>
      </div>
    </div>
  );
}

function MiniProgressPreview() {
  return (
    <div style={{ background: 'var(--paper-2)', border: '1px solid var(--line)', borderRadius: 14, padding: 14, boxShadow: '0 8px 24px -12px rgba(0,0,0,0.4)' }}>
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div style={{ width: 44, height: 64, borderRadius: 5, background: 'linear-gradient(135deg, #7a3b1e, #3d1c10)', flexShrink: 0, boxShadow: 'inset -2px 0 0 rgba(0,0,0,0.25)' }} />
        <div style={{ flex: 1 }}>
          <div style={{ fontFamily: 'Instrument Serif, Georgia, serif', fontSize: 16, color: 'var(--ink)' }}>página 187 / 264</div>
          <div style={{ height: 7, borderRadius: 999, background: 'var(--paper-3)', marginTop: 8, overflow: 'hidden' }}>
            <div style={{ height: '100%', width: '70%', borderRadius: 999, background: 'linear-gradient(90deg, var(--ember), var(--ember-soft, #E87A3B))' }} />
          </div>
          <div style={{ fontSize: 11, color: 'var(--ink-3)', marginTop: 6 }}>🔥 sequência de 12 dias</div>
        </div>
      </div>
    </div>
  );
}

function MiniMilestonePreview() {
  return (
    <div style={{ background: 'linear-gradient(160deg, var(--ember-soft, #3C2A1C), var(--paper-2) 70%)', border: '1px solid var(--line)', borderRadius: 14, padding: 14, boxShadow: '0 8px 24px -12px rgba(0,0,0,0.4)' }}>
      <div style={{ fontSize: 10, color: 'var(--ember)', fontWeight: 700, letterSpacing: '0.06em', marginBottom: 6 }}>● MARCO 3 ATIVO</div>
      <div style={{ fontFamily: 'Instrument Serif, Georgia, serif', fontSize: 18, color: 'var(--ink)', lineHeight: 1.15 }}>Parte II — até a página 140</div>
      <div style={{ height: 6, borderRadius: 999, background: 'var(--paper-3)', marginTop: 10, overflow: 'hidden' }}>
        <div style={{ height: '100%', width: '55%', borderRadius: 999, background: 'linear-gradient(90deg, var(--ember), var(--ember-soft, #E87A3B))' }} />
      </div>
      <div style={{ fontSize: 11, color: 'var(--ink-3)', marginTop: 6 }}>faltam 21 páginas · 12 estudos no marco</div>
    </div>
  );
}

function MiniRankingPreview() {
  const rows = [['Ana', '1.240', '🥇'], ['Você', '980', '🥈'], ['Caio', '760', '🥉']];
  return (
    <div style={{ background: 'var(--paper-2)', border: '1px solid var(--line)', borderRadius: 14, padding: 12, boxShadow: '0 8px 24px -12px rgba(0,0,0,0.4)' }}>
      {rows.map(([name, pts, medal], i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 4px', borderBottom: i < 2 ? '1px solid var(--line)' : 'none' }}>
          <span style={{ fontSize: 16 }}>{medal}</span>
          <div style={{ width: 24, height: 24, borderRadius: '50%', background: name === 'Você' ? 'var(--ember)' : 'var(--paper-3)' }} />
          <span style={{ flex: 1, fontSize: 13, color: 'var(--ink)', fontWeight: name === 'Você' ? 700 : 400 }}>{name}</span>
          <span style={{ fontSize: 12, color: 'var(--ink-3)', fontFamily: 'monospace' }}>{pts} pág</span>
        </div>
      ))}
    </div>
  );
}

function MiniPeoplePreview() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: -8, padding: '8px 0' }}>
      {['#E87A3B', '#7FA8A6', '#C08CAE', '#9EB083', '#E8C77B'].map((c, i) => (
        <div key={i} style={{ width: 46, height: 46, borderRadius: '50%', background: `linear-gradient(135deg, ${c}, ${c}99)`, marginLeft: i ? -12 : 0, border: '3px solid var(--paper)', boxShadow: '0 4px 12px -4px rgba(0,0,0,0.4)' }} />
      ))}
    </div>
  );
}

// ── Monta os cards dinamicamente pela config do clube ──
function buildCards({ club, term }) {
  const T = term === 'grupo' ? 'grupo' : 'clube';
  const isGroupRead = club?.mode === 'group-read';
  const role = club?.yourRole || 'member';
  const isLeader = role === 'owner' || role === 'admin';
  const isMod = isLeader || role === 'moderator';
  const rules = club?.rules || {};
  const postBy = rules.postBy || 'all';
  const cards = [];

  // 1. Boas-vindas
  cards.push({
    key: 'welcome',
    illo: <MiniPeoplePreview />,
    eyebrow: 'Você entrou!',
    title: `Bem-vindo ao ${club?.name || (T === 'grupo' ? 'grupo' : 'clube')}`,
    body: isLeader
      ? `Você é o líder aqui. Este tour mostra o que você controla e o que os membros podem fazer.`
      : `Que bom te ver aqui. Em 30 segundos você entende como esse ${T} funciona e o que dá pra fazer.`,
  });

  // 2. Como funciona (modo)
  cards.push({
    key: 'mode',
    illo: <MiniProgressPreview />,
    eyebrow: isGroupRead ? 'Leitura em grupo' : 'Cada um o seu',
    title: isGroupRead ? 'Vocês leem o mesmo livro' : 'Cada um lê o seu livro',
    body: isGroupRead
      ? `Aqui todos leem o MESMO livro, no mesmo ritmo. ${isLeader ? 'Você define o livro e os marcos de leitura.' : 'O líder define o livro e os marcos; você acompanha e registra seu progresso.'}`
      : `Aqui cada pessoa lê o SEU próprio livro — mas vocês mantêm o hábito juntos. Você monta sua própria sequência de leituras e registra seu avanço.`,
  });

  // 3. O que você pode fazer (permissões dinâmicas)
  const can = [];
  if (postBy === 'all') can.push(['edit', 'Postar no Estudo', 'Compartilhe reflexões, citações e perguntas sobre a leitura.']);
  else if (postBy === 'leader-only') can.push(['chat', 'Comentar e reagir', 'Só o líder abre posts; você participa comentando e reagindo.']);
  else if (postBy === 'moderators') can.push(['chat', 'Comentar e reagir', 'Líder e moderadores postam; você comenta, reage e debate.']);
  else if (postBy === 'approval') can.push(['edit', 'Postar (com aprovação)', 'Você posta reflexões e o líder aprova antes de publicar.']);
  if (isMod && postBy !== 'all') can.push(['edit', 'Postar no Estudo', 'Como ' + (isLeader ? 'líder' : 'moderador') + ', você abre posts pra todo o grupo.']);
  can.push(['flame', 'Registrar leitura', 'Marque suas páginas todo dia e mantenha sua sequência (streak).']);
  if (rules.allowMemberQuiz || isLeader) can.push(['help', 'Criar quiz', 'Monte quizzes pra testar o grupo no que foi lido.']);
  if (rules.publicRanking) can.push(['star', 'Ranking de leitura', 'Veja quem está lendo mais — uma competição amigável.']);
  if (rules.allowPoke) can.push(['bell', 'Cutucar membros', 'Dê aquele empurrãozinho em quem sumiu da leitura.']);
  if (isLeader) can.push(['sparkle', 'Ferramentas de líder', 'Defina livros e marcos, modere posts e responda a caixa de perguntas.']);

  cards.push({ key: 'can', isList: true, eyebrow: 'O que dá pra fazer aqui', title: 'Suas ferramentas', list: can });

  // 4. Estudo & discussão
  cards.push({
    key: 'estudo',
    illo: <MiniPostPreview />,
    eyebrow: 'Estudo do livro',
    title: 'Leitura vira conversa',
    body: `No Estudo, o grupo reflete sobre o livro: reflexões profundas, citações marcantes, perguntas e até lições. ${postBy === 'leader-only' ? 'Você comenta e reage em tudo.' : 'Comente, reaja e puxe discussão.'}`,
  });

  // 4b. Stories do grupo (somem em 24h)
  cards.push({
    key: 'stories',
    illo: <div style={{ fontSize: 54, textAlign: 'center' }}>📸</div>,
    eyebrow: 'Stories do grupo',
    title: 'Momentos que somem em 24h',
    body: 'No topo do Estudo, o grupo compartilha Stories — fotos, citações e recados do dia que desaparecem depois de 24 horas. Toque nos círculos pra ver, e poste os seus (se o líder permitir) pra dar o tom da leitura.',
  });

  // 5. Marcos (só group-read)
  if (isGroupRead) {
    cards.push({
      key: 'marcos',
      illo: <MiniMilestonePreview />,
      eyebrow: 'Marcos de leitura',
      title: 'Avancem no mesmo ritmo',
      body: isLeader
        ? 'Você define marcos (ex.: "até a página 140 nesta semana"). O grupo lê junto e, ao fechar um marco, você publica um Insight Final.'
        : 'O líder define marcos de leitura — metas que o grupo persegue junto. Você acompanha seu progresso rumo a cada marco.',
    });
  }

  // 6. Ranking (se público)
  if (rules.publicRanking) {
    cards.push({
      key: 'ranking',
      illo: <MiniRankingPreview />,
      eyebrow: 'Ranking',
      title: 'Quem está voando na leitura',
      body: 'Cada página lida conta. O ranking mostra os mais ativos do grupo — sem pressão, só pra manter o ânimo.',
    });
  }

  // 7. Pronto
  cards.push({
    key: 'done',
    illo: <div style={{ fontSize: 56, textAlign: 'center' }}>📖</div>,
    eyebrow: 'Tudo pronto',
    title: 'Bora ler junto',
    body: isGroupRead
      ? 'Pegue o livro do grupo e registre sua leitura. E se ainda não tiver o livro, sem problema: dá pra só acompanhar os estudos da comunidade por aqui — você não precisa do livro pra participar.'
      : 'Adicione seu primeiro livro à sua sequência e registre sua leitura de hoje. Sem o livro ainda? Dá pra só acompanhar os estudos do grupo enquanto não começa.',
    final: true,
  });

  return cards;
}

export const ClubWelcomeTour: React.FC<{
  open: boolean;
  club: any;
  term?: 'clube' | 'grupo';
  onClose: () => void;
}> = ({ open, club, term = 'clube', onClose }) => {
  const [i, setI] = useState(0);
  const cards = React.useMemo(() => buildCards({ club, term }), [club, term]);
  if (!open) return null;
  const card = cards[i];
  const last = i === cards.length - 1;
  const next = () => last ? onClose() : setI(v => Math.min(v + 1, cards.length - 1));
  const prev = () => setI(v => Math.max(v - 1, 0));

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9500, background: 'var(--paper)',
      display: 'flex', flexDirection: 'column', maxWidth: 460, margin: '0 auto',
      animation: 'e2FadeUp 0.25s ease both',
    }}>
      {/* topo: progresso + pular */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 'calc(16px + env(safe-area-inset-top,0px)) 18px 8px' }}>
        <div style={{ flex: 1, display: 'flex', gap: 5 }}>
          {cards.map((_, k) => (
            <div key={k} style={{ flex: 1, height: 3.5, borderRadius: 999, background: k <= i ? 'var(--ember)' : 'var(--paper-3)', transition: 'background 0.3s' }} />
          ))}
        </div>
        {!last && <button onClick={onClose} style={{ fontSize: 13.5, color: 'var(--ink-3)', fontWeight: 600, padding: '4px 6px', background: 'none', border: 'none' }}>Pular tour</button>}
      </div>

      {/* corpo do card */}
      <div key={card.key} style={{ flex: 1, overflowY: 'auto', padding: '14px 24px 24px', display: 'flex', flexDirection: 'column', justifyContent: 'center', animation: 'e2FadeUp 0.3s ease both' }}>
        <div style={{ marginBottom: 26 }}>{card.illo}</div>
        <div className="mono" style={{ fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--ember)', fontWeight: 700, marginBottom: 8 }}>{card.eyebrow}</div>
        <h2 style={{ fontFamily: 'Instrument Serif, Georgia, serif', fontSize: 30, lineHeight: 1.1, color: 'var(--ink)', margin: '0 0 14px' }}>{card.title}</h2>
        {card.isList ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 4 }}>
            {card.list.map(([icon, t, d], k) => (
              <div key={k} style={{ display: 'flex', gap: 13, alignItems: 'flex-start' }}>
                <div style={{ width: 38, height: 38, borderRadius: 11, background: 'var(--ember-soft, #3C2A1C)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Icon name={icon} size={18} color="var(--ember)" />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--ink)' }}>{t}</div>
                  <div style={{ fontSize: 13, color: 'var(--ink-3)', marginTop: 2, lineHeight: 1.45 }}>{d}</div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p style={{ fontSize: 15.5, lineHeight: 1.6, color: 'var(--ink-2)', margin: 0 }}>{card.body}</p>
        )}
      </div>

      {/* rodapé: voltar + próximo */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 18px calc(20px + env(safe-area-inset-bottom,0px))', borderTop: '1px solid var(--line)' }}>
        {i > 0
          ? <button onClick={prev} style={{ padding: '13px 18px', borderRadius: 12, background: 'var(--paper-2)', border: '1px solid var(--line)', color: 'var(--ink-2)', fontSize: 14, fontWeight: 600 }}>Voltar</button>
          : <div style={{ width: 1 }} />}
        <button onClick={next} style={{
          flex: 1, padding: '14px', borderRadius: 12, background: 'var(--ember)', color: '#fff',
          fontSize: 15, fontWeight: 700, border: 'none', boxShadow: '0 10px 24px -8px rgba(199,83,26,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
        }}>
          {last ? 'Começar' : 'Próximo'}
          {!last && <Icon name="chevron-right" size={16} color="#fff" />}
        </button>
      </div>
    </div>
  );
};
